/* eslint-disable */
import Helper from "../util/Helper";

export default {
    init() {
        var $body = $('body'),
            classOpen = 'open',
            $navbarMain = $('#primary'),
            $primaryDropdown = $navbarMain.find('.menu-item.dropdown'),
            fixedClass = 'fixed',
            headerHeight = $('.header-main').outerHeight();
        headerHeight = headerHeight > 150 ? 110 : headerHeight;

        // JavaScript to be fired on all pages
        $('.toggle-submenu').on('click', function (e) {
            e.preventDefault();
            var $dropdownItem = $(this).parents('.nav-item.dropdown');
            if (!$dropdownItem.hasClass(classOpen)) {
                $dropdownItem.addClass(classOpen);
                $dropdownItem.find('.dropdown-menu').first().stop(true, true).slideDown(200);
            } else {
                $dropdownItem.removeClass(classOpen);
                $dropdownItem.find('.dropdown-menu').first().stop(true, true).slideUp(200);
            }
        });

        $navbarMain.on('shown.bs.collapse', function () {
            $body.addClass(classOpen);
        }).on('hidden.bs.collapse', function () {
            $body.removeClass(classOpen);
        });

        $(document).scroll(function () {
            let scrollPosition = $(window).scrollTop();
            // store threshold for later use
            if (typeof window.stickyThreshold === 'undefined') {
                window.stickyThreshold = headerHeight;
            }
            if (scrollPosition > window.stickyThreshold) {
                $body.addClass(fixedClass);
            } else {
                $body.removeClass(fixedClass);
            }
            return;
        });

        if (!Helper.smallScreenHelper(Helper.ipadMediumBreakpoint)) {
            $primaryDropdown.on('mouseenter', function () {
                $(this).find('.dropdown-menu').first().slideDown(300);
                $(this).addClass(classOpen);
            }).on('mouseleave', function () {
                $(this).find('.dropdown-menu').first().stop(true, true).slideUp(300);
                $(this).removeClass(classOpen);
            });
        }

        $('a[href*="#"]').click(function (e) {
            if (Helper.checkLocation(this)) {
                var $target = $(this.hash);
                if (this.hash.length && $target.length) {
                    e.preventDefault();
                    Helper.smoothScroll($target, headerHeight + 15);
                }
            }
        });

        if (window.addEventListener) {
            window.addEventListener('load', () => {
                if (location.hash && location.hash !== '#') {
                    let anchorLocation = decodeURIComponent(location.hash),
                        anchorElement = document.querySelector(anchorLocation);
                    if (anchorElement && anchorElement.offsetTop) {
                        setTimeout(() => anchorElement.scrollIntoView(), 100);
                    }
                }
            }, false);
        }

        // set cookie for google analytics user_id and fill hidden input
        if (typeof window.BorlabsCookie !== 'undefined') {
            if (window.BorlabsCookie.checkCookieConsent('google-analytics')) {
                if (!Helper.getCookie('gaUserId')) {
                    Helper.setCookie('gaUserId', main_js_vars.microtime);
                }
            } else if (Helper.getCookie('gaUserId')) {
                Helper.deleteCookie('gaUserId');
            }
        }

        // show collapse content on desktop
        if (!Helper.smallScreenHelper(Helper.xsBreakpoint)) {
            $('.footer-col .collapse, .filter-list .collapse, .collapse-mobile').collapse('show');
            $('.footer-col .nav-title').on('click', function (e) {
                e.preventDefault();
                return false;
            });
        }

        if (Helper.smallScreenHelper(Helper.fullBreakpoint)) {
            $('.cost-table-content-item .collapse-header').on('click', function (e) {
                var collapseTarget = $(this).data('target');
                $(this).toggleClass(classOpen);
                $(collapseTarget).slideToggle();
            });
        }

        $('.table-contents a, .all-anchor, .all-anchor-mobile, .ratgeber-anchor').on('click', function (e) {
            e.preventDefault();
            var $target = $(this.hash);
            Helper.smoothScroll($target);
        });

        if ($('.single-ratgeber .post-content h2').length > 0) {
            var num = 1,
                $text = '';
            $('.single-ratgeber .post-content h2').each(function () {
                $text = $(this).text();
                $(this).attr('id', Helper.replaceChars($text));
                $(this).wrap('<div class="headline-anchor-wrapper"></div>');
                $(this).before('<span class="headline-num">' + num + '</span>');
                ++num;
            });
        }

        if ($('.single-product .matching-ratgeber h2').length > 0) {
            var num = 1,
                $text = '';
            $('.single-product .matching-ratgeber h2:not(.post-title)').each(function () {
                $text = $(this).text();
                $(this).attr('id', Helper.replaceChars($text));
                $(this).wrap('<div class="headline-anchor-wrapper"></div>');
                $(this).before('<span class="headline-num">' + num + '</span>');
                ++num;
            });
        }

        $('.btn-more-pricing').on('click', function (e) {
            e.preventDefault();
            $(this).toggleClass('up');
            $(this).prev('.second').slideToggle(200);
            var str = $(this).find('#swap-text');
            if (str.text() === str.data('text-swap')) {
                str.text(str.data('text-original'));
            } else {
                str.text(str.data('text-swap'));
            }
        });

        $('.more').on('click', function (e) {
            e.preventDefault();
            $(this).find('.icon-rm').toggleClass('up');
            $(this).prev('.tickboxes').slideToggle(200);
            var str = $(this).find('#swap-text');
            if (str.text() === str.data('text-swap')) {
                str.text(str.data('text-original'));
            } else {
                str.text(str.data('text-swap'));
            }
        });

        $('.contact-desktop').on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            $(this).next().slideToggle(200);
            $(this).parent().toggleClass('show-contact-info');
        });

        $('.interview-element .btn-more').on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            $(this).toggleClass('up');
            $(this).parent().prev().find('.hidden').slideToggle(200);
        });

        $('.template-presse .more').on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            $('a.hidden').slideToggle(200);
        });

        if ($('.trim-posts .hide').length) {
            $('.trim-posts .load-more').on('click', function (e) {
                e.preventDefault();
                var parentElement = $(this).parents('.trim-posts').first();
                $(parentElement).find('.hide').removeClass('hide');
                $(this).hide();
            });
        }

        $('.more-rgb').on('click', function (e) {
            $(this).prev().find('.too-much').slideToggle(200);
            var str = $(this).find('#swap-text');
            if (str.text() === str.data('text-swap')) {
                str.text(str.data('text-original'));
            } else {
                str.text(str.data('text-swap'));
            }
            $(this).toggleClass('up');
        });

        $('#marquee').hover(
            function () {
                $(this).children().addClass('stopped');
            },
            function () {
                $(this).children().removeClass('stopped');
            }
        );

        if (document.getElementById('marquee')) {
            var laufschrift = $('#marquee');
            var len = laufschrift.find('span').text().length;
            laufschrift.find('span').css('animation-duration', len / 12 + 's');
        }

        $('.faq-head').on('click', function (e) {
            var $faqHead = $(this);
            e.preventDefault();
            $faqHead.toggleClass(classOpen);
            $faqHead.find('.icon-rm').toggleClass('up');
            $faqHead.next('.faq-content').slideToggle(300);
        });

        $('.accordion').on('click', function (e) {
            var $accHead = $(this);
            e.preventDefault();
            $accHead.find('p').toggleClass(classOpen);
            $accHead.find('ul').slideToggle(300);
        });

        $('.ratgeber-toggle').on('click', function (e) {
            e.preventDefault();
            $(this).find('.icon-rm').toggleClass('up');
            $(this).prev('.element-section').slideToggle(200);
            var str = $(this).find('#swap-text');
            if (str.text() === str.data('text-swap')) {
                str.text(str.data('text-original'));
            } else {
                str.text(str.data('text-swap'));
            }
        });

        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has('referral')) {
            localStorage.setItem('referral', urlParams.get('referral'));
        }
        var referral = localStorage.getItem('referral');
        if (referral) {
            $('a[href*="rightmart.group/formular/"]').each(function () {
                var href = $(this).attr('href');
                href += (href.includes('?') ? '&' : '?') + 'referral=' + referral;
                $(this).attr('href', href);
            });
        }

        $('.fsCell').each(function () {
            if ($(this).attr('fs-field-validation-name') === 'referral') {
                $(this).find('.fsField').attr('value', referral);
            }
        });

        if (Helper.smallScreenHelper(Helper.xsBreakpoint)) {
            $('.anchor-links .wrapper').hide();
            $('.anchor-title').on('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
                $(this).next().slideToggle(200);
                $(this).toggleClass(classOpen);
            });
        }

        $('.anchor-links').each(function () {
            var $wrapper = $(this).find('.wrapper'),
                items = $wrapper.children(),
                mouseDown = false,
                dragging = false,
                startX,
                startScroll,
                smallScreen = Helper.smallScreenHelper(Helper.ipadBreakpoint);

            if (!smallScreen) {
                $wrapper.on('mousedown', function (e) {
                    e.preventDefault();
                    mouseDown = true;
                    startX = e.pageX;
                    startScroll = $wrapper.scrollLeft();
                });

                $wrapper.on('mouseleave mouseup', function (e) {
                    mouseDown = false;
                });

                $(items).click(function (e) {
                    if (dragging) {
                        e.preventDefault();
                    }
                });

                $wrapper.on('mousemove', function (e) {
                    dragging = mouseDown;
                    if (!mouseDown) {
                        return;
                    }
                    e.preventDefault();
                    var x = e.pageX;
                    $wrapper.scrollLeft(startScroll + startX - x);
                });
            }
        });

        $('.category .product-card-wrapper-new').each(function () {
            var $wrapper = $(this).find('.product-list'),
                items = $wrapper.children(),
                $prev = $(this).find('.scroll-arrow-prev'),
                $next = $(this).find('.scroll-arrow-next'),
                smallScreen = Helper.smallScreenHelper(Helper.ipadBreakpoint),
                $pageContent = $(this).find('.pagination .page'),
                $pageTotalContent = $(this).find('.pagination .page-total'),
                $page = 1,
                $pageTotal;

            if ((items.length % 3) === 0) {
                $pageTotal = Math.floor(items.length / 3);
            } else {
                $pageTotal = Math.floor(items.length / 3) + 1;
            }
            if (items.length < 4) {
                $prev.hide();
                $next.hide();
                $('.pagination').hide();
            }

            if (!smallScreen) {
                $pageTotalContent.replaceWith($pageTotal);

                function checkArrows(value) {
                    if (value <= 0) {
                        $prev.addClass('not-active');
                    } else {
                        $prev.removeClass('not-active');
                    }
                    if (value >= $wrapper.prop('scrollWidth') - $wrapper.outerWidth() || $wrapper.offsetWidth < $wrapper.scrollWidth) {
                        $next.addClass('not-active');
                    } else {
                        $next.removeClass('not-active');
                    }
                }

                function scroll(steps) {
                    var value = $wrapper.scrollLeft() + ($(items[0]).outerWidth() + 32) * steps;
                    $wrapper.animate({scrollLeft: value}, 300);
                    checkArrows(value);
                }

                $prev.click(function () {
                    scroll(-3);
                    if ($page > 1) {
                        $pageContent.text(function (index, text) {
                            return text.replace($pageContent.text(), --$page);
                        });
                    }
                });

                $next.click(function () {
                    scroll(3);
                    if ($page < $pageTotal) {
                        $pageContent.text(function (index, text) {
                            return text.replace($pageContent.text(), ++$page);
                        });
                    }
                });
                checkArrows(0);

                $(window).resize(function () {
                    var newSmallScreen = Helper.smallScreenHelper(Helper.ipadBreakpoint);
                    if (newSmallScreen === smallScreen) {
                        return;
                    }
                    smallScreen = newSmallScreen;
                    checkArrows($wrapper.scrollLeft());
                });
            }
        });

        // force the browser to take user to the top of the page
        $(window).load(function () {
            $('html, body').animate({scrollTop: 0}, 10);
        });
        var defaultSliderSettings = {
                arrows: true,
                dots: true,
                infinite: true,
                autoplay: false,
                slidesToShow: 4,
                responsive: [
                    {
                        breakpoint: Helper.ipadLandBreakpoint,
                        settings: {
                            slidesToShow: 3,
                            infinite: false,
                        }
                    },
                    {
                        breakpoint: Helper.ipadBreakpoint,
                        settings: {
                            slidesToShow: 2,
                            infinite: false,
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            infinite: false,
                        }
                    }
                ]
            },
            mobileSliderSettings = {
                arrows: true,
                dots: true,
                infinite: false,
                autoplay: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                mobileFirst: true,
                cssEase: 'linear',
                responsive: [
                    {
                        breakpoint: Helper.ipadBreakpoint,
                        settings: {
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: Helper.xsBreakpoint,
                        settings: {
                            slidesToShow: 1,
                        }
                    },
                    {
                        breakpoint: Helper.ipadLandBreakpoint,
                        settings: 'unslick'
                    },
                ]
            },
            postSliderSettings = {
                arrows: true,
                dots: true,
                infinite: false,
                autoplay: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                mobileFirst: true,
                cssEase: 'linear',
                responsive: [
                    {
                        breakpoint: Helper.xsBreakpoint,
                        settings: {
                            slidesToShow: 1,
                        }
                    },
                    {
                        breakpoint: Helper.ipadBreakpoint,
                        settings: 'unslick'
                    },
                    {
                        breakpoint: Helper.ipadLandBreakpoint,
                        settings: 'unslick'
                    },
                ]
            }, maxDots = 8;
        $('.slider').on('init', function (e, slick) {
            var element = e.currentTarget;
            if ($(element).find('.slick-arrow').length && $(element).find('.slick-dots').length) {
                var dotWrapperClass = slick.slideCount > maxDots ? ' d-none d-md-block' : '';
                $(element).find('.slick-dots').wrap('<div class="slick-controls"></div>');
                $(element).find('.slick-prev').insertBefore($(element).find('.slick-dots'));
                $(element).find('.slick-next').insertAfter($(element).find('.slick-dots'));
                $(element).find('.slick-dots').wrap('<div class="slick-dots-container' + dotWrapperClass + '"></div>');
                $(element).find('ul.slick-dots li').each(function (index) {
                    $(this).addClass('dot-index-' + index);
                });
            }
        });

        $('.slider.slider-mobile').slick(mobileSliderSettings);
        $('.slider.col-posts').slick(postSliderSettings);
        $('.slider:not(.slider-mobile):not(.col-posts):not(.slick-initialized)').slick(defaultSliderSettings);
    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js